import { combineReducers } from '@reduxjs/toolkit';
import CamReducer from './camera/Reducer';
import profleDataReducer from './profile/Reducer';
import { AgreementCheckBoxReducer } from './agreementCheckbox/Reducer';
import { apiBasePath } from './services/baseUrl';

export const reducers = combineReducers({
  camera: CamReducer,
  profile: profleDataReducer,
  api: apiBasePath.reducer,
  agreementCheckboxes: AgreementCheckBoxReducer.reducer
});
